import { longCurrenciesName } from "common/constants";

interface SelectCurrenciesListProps {
      selectedCurrencyList: DefaultCurrency[];
      setSelectedCurrencyList: (value: DefaultCurrency[]) => void;
}
  
function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }
  
  function SelectCurrenciesList({
    selectedCurrencyList,
    setSelectedCurrencyList,
  }: SelectCurrenciesListProps) {
    const currenciesList: DefaultCurrency[] = [
     'USD', 'AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'MXN', 'RUB', 'ZAR'
    ];
  
    const desktopChunks = chunkArray(currenciesList, 3);
    const mobileChunks = chunkArray(currenciesList, 2);
  
    return (
      <div className="flex flex-col space-y-2 w-2/3 lg:w-auto">
        {/* Desktop view */}
        <div className="hidden md:flex flex-col space-y-2">
          {desktopChunks.map((row, idx) => (
            <div key={idx} className="flex space-x-2">
              {row.map(currency => (
                <CurrencyItem
                  key={currency}
                  currency={currency}
                  selectedCurrencyList={selectedCurrencyList}
                  setSelectedCurrencyList={setSelectedCurrencyList}
                />
              ))}
            </div>
          ))}
        </div>
  
        {/* Mobile view */}
        <div className="flex md:hidden flex-col space-y-1">
          {mobileChunks.map((row, idx) => (
            <div key={idx} className="flex space-x-1">
              {row.map(currency => (
                <CurrencyItem
                  key={currency}
                  currency={currency}
                  selectedCurrencyList={selectedCurrencyList}
                  setSelectedCurrencyList={setSelectedCurrencyList}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  
  export default SelectCurrenciesList;

  const CurrencyItem = ({ currency, selectedCurrencyList, setSelectedCurrencyList }: { currency: DefaultCurrency; selectedCurrencyList: DefaultCurrency[]; setSelectedCurrencyList: (value: DefaultCurrency[]) => void; }) => {
    return (
      <div className="flex items-center" key={currency}>
        <label className="text-[12px] lg:text-[14px] flex items-center">
          {longCurrenciesName[currency]}
          <input
            disabled={(selectedCurrencyList.includes(currency) && selectedCurrencyList.length <= 1)}
            type="checkbox"
            value={currency}
            checked={selectedCurrencyList.includes(currency)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedCurrencyList([...selectedCurrencyList, currency]);
              } else {
                setSelectedCurrencyList(selectedCurrencyList.filter(item => item !== currency));
              }
            }}
            className='mx-1 h-[15px] w-[15px] cursor-pointer'
          />
        </label>
      </div>
    );
  }; 